import * as Sentry from '@sentry/svelte';
import App from './App.svelte';
import CuratedByApp from './CuratedByApp.svelte';

// Initialize the Sentry SDK here
if (window.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://4ea67c88d2554269a8b7f5b557bf39fc@o19778.ingest.sentry.io/4505483989286912',
    integrations: [new Sentry.BrowserTracing({ tracingOrigins: ['*'] })],
    environment: window.NODE_ENV,
    // NOTE: sourced these lists from: https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      // https://gist.github.com/impressiver/5092952?permalink_comment_id=4568003#gistcomment-4568003
      /.*@webkit-masked-url.*/,
    ],
    denyUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
  });
}

function getAppComponent() {
  const { hostname } = window.location;
  if (hostname.includes('curatedby') || hostname === '127.0.0.1') {
    return CuratedByApp;
  }
  return App;
}

const app = new (getAppComponent())({
  target: document.body,
});

export default app;
